export enum EConfirmationDialogFields {
  title = 'title',
  content = 'content',
  okButtonLabel = 'okButtonLabel',
  cancelButtonLabel = 'cancelButtonLabel'
}
